import { SupportedLocale } from '@/utils/i18n/supportedLocales';

export type LocaleMessages = Record<
  string,
  | { message: string; description?: string }
  | { defaultMessage: string; description?: string }
>;

/** Flattens a loaded locale catalog to the `Record<string, string>` shape react-intl expects. */
export const toIntlMessages = (messages: LocaleMessages): Record<string, string> =>
  Object.fromEntries(
    Object.entries(messages).map(([key, value]) => [
      key,
      'message' in value ? value.message : value.defaultMessage,
    ])
  );

export const localeMessageLoaders: Partial<
  Record<SupportedLocale, () => Promise<{ default: LocaleMessages }>>
> = {
  [SupportedLocale.ArSa]: () => import('@/locales/ar-SA/messages.json'),
  [SupportedLocale.CaEs]: () => import('@/locales/ca-ES/messages.json'),
  [SupportedLocale.DaDk]: () => import('@/locales/da-DK/messages.json'),
  [SupportedLocale.DeDe]: () => import('@/locales/de-DE/messages.json'),
  [SupportedLocale.EsEs]: () => import('@/locales/es-ES/messages.json'),
  [SupportedLocale.FiFi]: () => import('@/locales/fi-FI/messages.json'),
  [SupportedLocale.FrFr]: () => import('@/locales/fr-FR/messages.json'),
  [SupportedLocale.ItIt]: () => import('@/locales/it-IT/messages.json'),
  [SupportedLocale.JaJp]: () => import('@/locales/ja-JP/messages.json'),
  [SupportedLocale.KoKr]: () => import('@/locales/ko-KR/messages.json'),
  [SupportedLocale.NlNl]: () => import('@/locales/nl-NL/messages.json'),
  [SupportedLocale.NbNo]: () => import('@/locales/nb-NO/messages.json'),
  [SupportedLocale.PlPl]: () => import('@/locales/pl-PL/messages.json'),
  [SupportedLocale.PtPt]: () => import('@/locales/pt-PT/messages.json'),
  [SupportedLocale.SvSe]: () => import('@/locales/sv-SE/messages.json'),
  [SupportedLocale.ZhCn]: () => import('@/locales/zh-CN/messages.json'),
  [SupportedLocale.ZhTw]: () => import('@/locales/zh-TW/messages.json'),
};
